import React from 'react';
import OnamDay2024 from 'views/OnamDay2024';

const OlympiadPage = () => {
  return <OnamDay2024 />;
};

export default OlympiadPage;